import type { ForceGraph3DInstance, NodeObject, LinkObject } from "3d-force-graph";
import { Vector3 } from "three";

export const getLabelOpacityUpdater = (
  Graph: ForceGraph3DInstance<NodeObject, LinkObject<NodeObject>>,
  nodeElements: Map<string, HTMLElement>,
) => {
  let lastPosition: Vector3 = new Vector3(0, 0, 0);

  const updateLabelOpacity = (force = false) => {
    const camera = Graph.camera();
    const cameraPosition = camera.position;

    if (lastPosition.equals(cameraPosition) && !force) return;
    lastPosition = cameraPosition.clone();

    // Get all nodes from the graph
    const nodes = Graph.graphData().nodes;

    if (!nodes) return;

    // Calculate distances and find min/max for normalization
    const distances: number[] = [];
    const nodePositions = new Map<string, { x: number; y: number; z: number }>();

    nodes.forEach((node) => {
      if (node.x !== undefined && node.y !== undefined && node.z !== undefined) {
        const distance = Math.sqrt(
          (cameraPosition.x - node.x) ** 2 + (cameraPosition.y - node.y) ** 2 + (cameraPosition.z - node.z) ** 2,
        );
        distances.push(distance);
        nodePositions.set(node.id as string, { x: node.x, y: node.y, z: node.z });
      }
    });

    if (distances.length === 0) return;

    const minDistance = Math.min(...distances);
    const maxDistance = Math.max(...distances);
    const distanceRange = maxDistance - minDistance;

    // Update opacity for each node
    nodes.forEach((node) => {
      const element = nodeElements.get(node.id as string);
      if (element && nodePositions.has(node.id as string)) {
        const nodePos = nodePositions.get(node.id as string)!;
        const distance = Math.sqrt(
          (cameraPosition.x - nodePos.x) ** 2 +
            (cameraPosition.y - nodePos.y) ** 2 +
            (cameraPosition.z - nodePos.z) ** 2,
        );

        // Normalize distance to 0-1 range and invert (closer = higher opacity)
        const normalizedDistance = distanceRange > 0 ? (distance - minDistance) / distanceRange : 0;
        // Use exponential fall-off for faster opacity reduction
        const opacity = Math.max(0.2, (1 - normalizedDistance) ** 2.5); // Faster fall-off with exponential curve

        element.style.opacity = opacity.toString();
      }
    });
  };

  return updateLabelOpacity;
};
// Function to update label opacity based on distance from camera
export const updateLabelOpacity = (
  Graph: ForceGraph3DInstance<NodeObject, LinkObject<NodeObject>> | undefined,
  nodeElements: Map<string, HTMLElement>,
) => {
  if (!Graph) return;
};
